<template>
  <WithInplaceMessage
    :loading="isLoading"
    :block="false"
  >
    <template v-if="!isLoading">
      <PsEmpty
        v-if="!presetsStore.presets.length"
        title="Пресетов нет"
        size="small"
      />
      <div
        v-else
        class="preset-list"
      >
        <PresetItem
          v-for="preset in presetsStore.presets"
          :key="preset.id"
          :preset="preset"
          :onRename="rename"
          :onDelete="remove"
          @apply="emit('apply', $event)"
        />
      </div>
    </template>
  </WithInplaceMessage>
</template>

<script setup lang="ts">
import { useAsyncState } from '@vueuse/core'
import { inject } from 'vue'
import PresetItem from './PresetItem.vue'
import WithInplaceMessage from '@/ContextTab/components/UI/WithInplaceMessage/WithInplaceMessage.vue'
import PsEmpty from '@/ContextTab/components/UI/PsEmpty.vue'
import { usePublishedPresetsStore } from '@/ContextTab/stores/newsSet/published/presets'
import { NotificationHandlerKey } from '@/injectionKeys.ts'


const emit = defineEmits<{
  (e: 'apply', id: number): void
  (e: 'resetFilters'): void
}>()

const { onError } = inject(NotificationHandlerKey, { onError: console.error })

const presetsStore = usePublishedPresetsStore()

const { isLoading } = useAsyncState(presetsStore.fetchPresets, undefined, { onError })

const { executeImmediate: rename } = useAsyncState(presetsStore.renamePreset, undefined, {
  onError, onSuccess: () => {
    presetsStore.fetchPresets()
  }, immediate: false,
})

const { executeImmediate: remove } = useAsyncState(presetsStore.deletePreset, undefined, {
  onError, onSuccess: () => {
    presetsStore.fetchPresets()
  }, immediate: false,
})
</script>

<style scoped>
.preset-list {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.5rem;
  height: 100%;
  justify-content: flex-start;
  width: fit-content;
}
</style>
